import PropTypes from 'prop-types';
import { Typography, Box, TextField, Accordion, AccordionSummary, Stack, Autocomplete, Button } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';
import DeleteOutline from '@mui/icons-material/DeleteOutline';

ContactForm.propTypes = {
  contactData: PropTypes.object,
  setFormValue: PropTypes.func,
  deleteContact: PropTypes.func,
  contactTypes: PropTypes.array,
  index: PropTypes.number,
  title: PropTypes.string,
  id: PropTypes.string
}

export default function ContactForm({ contactData, setFormValue, contactTypes, title, deleteContact = null, index = -1, id = "contacts" })
{
  const setValue = (field, value) => setFormValue(form => {
    if (index > -1) {
      if (!form[id]) form[id] = [{}];
      form[id][index][field] = value;
      return { ...form };
    }
    if (!form[id]) form[id] = {};
    form[id][field] = value;
    return { ...form };
  });

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion>
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <Stack sx={{ mx: 2, mb: 2 }} spacing={1} >
        <Box>
          <Typography variant="subtitle1">Email</Typography>
          <TextField
            name="email"
            size="small"
            placeholder="Enter Email Address"
            fullWidth
            value={contactData?.email ?? ""}
            onChange={(e) => setValue("email", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">Contact Type*</Typography>
          <Autocomplete
            fullWidth
            size="small"
            value={contactTypes.find(type => type.value === contactData?.contactTypeId) ?? null}
            onChange={(event, val) => setValue("contactTypeId", val?.value ?? 0)}
            options={contactTypes}
            renderInput={(params) => <TextField {...params} placeholder="Contact Type" />}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">First Name</Typography>
          <TextField
            name="firstName"
            size="small"
            placeholder="Enter First Name"
            fullWidth
            value={contactData?.firstName ?? ""}
            onChange={(e) => setValue("firstName", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">Last Name</Typography>
          <TextField
            name="lastName"
            size="small"
            placeholder="Enter Last Name"
            fullWidth
            value={contactData?.lastName ?? ""}
            onChange={(e) => setValue("lastName", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">Phone</Typography>
          <TextField
            name="phone"
            size="small"
            placeholder="Enter Phone"
            fullWidth
            value={contactData?.phone ?? ""}
            onChange={(e) => setValue("phone", e.target.value)}
          />
        </Box>      
        <Box>
          <Typography variant="subtitle1">Cell</Typography>
          <TextField
            name="cell"
            size="small"
            placeholder="Enter Cell"
            fullWidth
            value={contactData?.cell ?? ""}
            onChange={(e) => setValue("cell", e.target.value)}
          />
        </Box>       

        {deleteContact && <Box>
          <Button startIcon={<DeleteOutline />} sx={{ display: "flex", justifySelf: "center", mt: 2 }} color="error" size="medium" variant="contained" onClick={deleteContact}>
            Delete
          </Button>        
        </Box>}
      </Stack>
    </Accordion>
  </Box>;
}
